import React from 'react';
import { useTranslation } from 'react-i18next';

interface ProgressProp {
    progress: string;
}
export const ProgressBar = ({ progress }: ProgressProp) => {
    const { t } = useTranslation();
    let progressIcon1,
        progressIcon2,
        progressIcon3 = 'next';
    let progressLineLeftColor,
        progressLineRightColor = '#999';
    let progressTitleActive = 3;
    let progressTitleMobile = '';

    const analyticsData = window['analyticsData'] || {};

    if (progress == 'create-account') {
        progressIcon1 = 'current';
        progressIcon2 = 'next';
        progressIcon3 = 'next';
        progressTitleActive = 1;
        progressLineLeftColor = '#999';
        progressLineRightColor = '#999';
        progressTitleMobile = 'Address';

        analyticsData.page = analyticsData.page || {};
        analyticsData.page.pageTitle = 'step1:address';
    } else if (progress == 'payment') {
        progressIcon1 = 'prev';
        progressIcon2 = 'current';
        progressIcon3 = 'next';
        progressTitleActive = 2;
        progressLineLeftColor = '#000';
        progressLineRightColor = '#999';
        progressTitleMobile = 'Payment';

        analyticsData.page = analyticsData.page || {};
        analyticsData.page.pageTitle = 'step2:payment';
    } else {
        progressIcon1 = 'prev';
        progressIcon2 = 'prev';
        progressIcon3 = 'current';
        progressTitleActive = 3;
        progressLineLeftColor = '#000';
        progressLineRightColor = '#000';
        progressTitleMobile = 'Review Order';

        analyticsData.page = analyticsData.page || {};
        analyticsData.page.pageTitle = 'step3:review order';
    }
    const svgIcon = progress => {
        switch (progress) {
            case 'prev':
                return (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="progressbar__svg">
                        <circle cx="12" cy="12" r="10" />
                        <path fill="#FFF" d="M6 15l2 3h1l4-6 5-5s-1-2-2-1l-5 6c-1 1-3 3-3 6h1l-1-4c-1-1-2 0-2 1z" />
                    </svg>
                );

            case 'current':
                return (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="progressbar__svg">
                        <path fill="none" d="M0 0h24v24H0V0z" />
                        <circle cx="12" cy="12" r="10" />
                        <path fill="#999" d="M12 2v20c5.5 0 10-4.5 10-10S17.5 2 12 2z" />
                        <path fill="#FFF" d="M12 4.8v14.5c4 0 7.3-3.2 7.3-7.3S16 4.8 12 4.8z" />
                    </svg>
                );
            default:
                return (
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="progressbar__svg">
                        <path fill="none" d="M0 0h24v24H0V0z" />
                        <circle fill="#999" cx="12" cy="12" r="10" />
                        <circle fill="#FFF" cx="12" cy="12" r="7.3" />
                    </svg>
                );
        }
    };
    return (
        <div className="progressbar__wrap">
            <div className="progressbar__address">
                <div
                    className="progressbar__title"
                    style={{ fontWeight: progressTitleActive == 1 ? 'bold' : 'normal' }}
                >
                    {t('Address')}
                </div>
                {svgIcon(progressIcon1)}
            </div>

            <div className="progressbar__payment">
                <div
                    className="progressbar__title"
                    style={{ fontWeight: progressTitleActive == 2 ? 'bold' : 'normal' }}
                >
                    {t('Payment')}
                </div>
                {svgIcon(progressIcon2)}
            </div>

            <div className="progressbar__review">
                <div
                    className="progressbar__title"
                    style={{ fontWeight: progressTitleActive == 3 ? 'bold' : 'normal' }}
                >
                    {t('Review Order')}
                </div>
                {svgIcon(progressIcon3)}
            </div>
            <div className="progressbar__line--left" style={{ borderColor: progressLineLeftColor }}></div>
            <div className="progressbar__line--right" style={{ borderColor: progressLineRightColor }}></div>
            <div className="progressbar__title--mobile">{progressTitleMobile}</div>
        </div>
    );
};
